import { CancelOutlined } from "@mui/icons-material";
import { Alert } from "@mui/material";
import { useState } from "react";
import { useEffect } from "react";
import { useRef } from "react";
import { Dropdown } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { devLog } from "utils/devLog";

const searchTypeMap = new Map();

function GSTMemberSearchForm(props) {
  const { t } = useTranslation();
  const formRef = useRef();
  const [last8Vin, setLast8Vin] = useState(props.currState.MemberLookup.last8Vin || props.currState.last8VIN || "");
  const [phone, setPhone] = useState(
    props.currState.MemberLookup.phone || props.currState?.Number?.replace(/\D/g, "") || "",
  );
  const [lessThanEightVin, setLessThanEightVin] = useState(false);

  const [searchTypes, setSearchTypes] = useState([
    { key: "PHONE", value: t("description.ConfirmCustomerPhoneNumber") },
    { key: "LAST8VIN", value: t("description.DropdownOptions1") },
  ]);

  const [selectedSearchTypes, setSelectedSearchTypes] = useState(props.currState.MemberLookup.searchType || "PHONE");

  useEffect(() => {
    setLast8Vin(last8Vin);
    setPhone(phone);
  }, [selectedSearchTypes]);

  useEffect(() => {
    if (typeof props.onFormUpdated === "function") {
      props.onFormUpdated({
        last8Vin: last8Vin,
        phone: phone,
        searchType: selectedSearchTypes,
      });
    }
  }, []);

  const onSubmit = (e) => {
    devLog("onSubmit", e);
    e.preventDefault();
    if (last8Vin.length < 8 && selectedSearchTypes === "LAST8VIN") {
      setLessThanEightVin(true);
      return;
    }
    if (typeof props.onFormSubmit === "function") {
      props.onFormSubmit({
        last8Vin: last8Vin,
        phone: phone,
        searchType: selectedSearchTypes,
      });
    }
    return false;
  };

  const vinInputLength = (e) => {
    if (e.target.value.length > 8) {
      e.target.value = e.target.value.slice(0, -1);
      devLog("Vin Length error");
    }
  };

  return (
    <>
      <div className="formContainer">
        <form ref={formRef} onSubmit={onSubmit} className="form">
          <Dropdown
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "10px",
            }}
          >
            <Dropdown.Toggle style={{ color: "white" }} variant="dark" id="dropdown-basic">
              {searchTypes.find((opt) => opt.key === selectedSearchTypes)?.value}
            </Dropdown.Toggle>
            <Dropdown.Menu variant="dark">
              {searchTypes.map((searchType) => {
                return (
                  <Dropdown.Item
                    active={searchType.key === selectedSearchTypes}
                    onClick={(e) => setSelectedSearchTypes(searchType.key)}
                  >
                    {searchType.value}
                  </Dropdown.Item>
                );
              })}
            </Dropdown.Menu>
          </Dropdown>

          {/*PHONE*/}
          {selectedSearchTypes === "PHONE" && (
            <>
              <div className="group-1">
                <div className="label">{t("FIMC.ContractSearch.DropdownOptions5")}:</div>
                <input
                  type="number"
                  // placeholder={t("description.DropdownOptions1")}
                  name="phone"
                  className="input form-control required"
                  value={phone}
                  onChange={(e) => {
                    setPhone(e.target.value?.trim() || "");
                  }}
                  required={true}
                />
              </div>
              {/* {lessThanEightVin && (
                <Alert severity="error">
                  {t("description.VinInputLessErrorMsg")}
                </Alert>
              )} */}
            </>
          )}

          {/*LAST 8 VIN*/}
          {selectedSearchTypes === "LAST8VIN" && (
            <>
              <div className="group-1">
                <div className="label">{t("description.DropdownOptions1")}:</div>
                <input
                  type="string"
                  placeholder={t("description.DropdownOptions1")}
                  name="last8Vin"
                  className="input form-control required"
                  value={last8Vin}
                  onChange={(e) => {
                    vinInputLength(e);
                    setLast8Vin(e.target.value?.trim()?.toUpperCase() || "");
                  }}
                  required={true}
                />
              </div>
              {lessThanEightVin && <Alert severity="error">{t("description.VinInputLessErrorMsg")}</Alert>}
            </>
          )}

          <div className="footerContainer">
            <div>
              <button
                id="cancelButton"
                type="button"
                className="footer"
                style={{
                  background: "#f4f4f4",
                  color: "black",
                  paddingLeft: 14,
                }}
                onClick={(e) => {
                  e.preventDefault();
                  devLog("UI Cancel pressed");
                  if (typeof props.onUserCancel === "function") {
                    props.onUserCancel();
                  }
                }}
              >
                <CancelOutlined style={{ width: 20, color: "black", marginRight: 4 }} />
                <span style={{ marginLeft: "0px" }}>{t("description.CancelCallButton1")}</span>
              </button>
            </div>
            <button type="submit" className="ui-btn">
              {t("description.ConfirmCustomerSubmit")}
            </button>
          </div>
        </form>
      </div>
    </>
  );
}

export default GSTMemberSearchForm;
